export function createStakingApi({ network }) {
  return {
    isStaking: ({ accountState }) => accountState.staking[network]?.isDelegating,
  }
}
